export const priceFormatter = (price: number | string): string => {
	if (typeof price !== 'number') {
		try {
			price = Number(price);
		} catch (error) {
			console.error(error);
		}
	}
	return `${price.toLocaleString('fi-FI', {
		style: 'currency',
		currency: 'EUR',
	})}`;
};
